import { render, staticRenderFns } from "./address-list.vue?vue&type=template&id=fa87314a&scoped=true&"
import script from "./address-list.vue?vue&type=script&lang=js&"
export * from "./address-list.vue?vue&type=script&lang=js&"
import style0 from "./address-list.sass?vue&type=style&index=0&id=fa87314a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87314a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VRadio,VRadioGroup})
